import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/registerSW";
import { hideSplash, isNative } from "@/lib/capacitor";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Web: register the existing service worker for PWA + Web Push.
// Native (Capacitor): skip the SW (it doesn't apply inside the shell) and
// dismiss the native splash screen once React has mounted.
if (isNative()) {
  // Give the first paint a beat so the splash → app transition feels smooth.
  requestAnimationFrame(() => setTimeout(hideSplash, 250));
} else {
  registerServiceWorker();
}
